import { SupportedModel } from "gitpod-next-api/gitpod/v1/agent_pb";
import { Provider } from "./types";

export const ANTHROPIC_ENDPOINT = "https://api.anthropic.com";

export const getModelDisplayName = (models: SupportedModel[]): string => {
    if (models.length === 0) return "No model configured";
    const model = models[0];
    switch (model) {
        case SupportedModel.SONNET_3_5:
            return "Claude 3.5 Sonnet";
        case SupportedModel.SONNET_3_7:
            return "Claude 3.7 Sonnet";
        case SupportedModel.SONNET_3_7_EXTENDED:
            return "Claude 3.7 Sonnet (Extended)";
        case SupportedModel.SONNET_4:
            return "Claude 4 Sonnet";
        case SupportedModel.SONNET_4_EXTENDED:
            return "Claude 4 Sonnet (Extended)";
        case SupportedModel.SONNET_4_5:
            return "Claude 4.5 Sonnet";
        case SupportedModel.SONNET_4_5_EXTENDED:
            return "Claude 4.5 Sonnet (Extended)";
        case SupportedModel.OPUS_4:
            return "Claude 4 Opus";
        case SupportedModel.OPUS_4_EXTENDED:
            return "Claude 4 Opus (Extended)";
        default:
            return "Unknown model";
    }
};

export const buildEndpointUrl = (
    provider: Provider,
    bedrockModelId: string,
    vertexRegion: string,
    vertexModelVersion: string,
    endpoint: string,
): string => {
    switch (provider) {
        case Provider.Anthropic:
            return ANTHROPIC_ENDPOINT;
        case Provider.Bedrock:
            return `bedrock://${bedrockModelId.trim()}`;
        case Provider.Vertex:
            return `vertex://${vertexRegion.trim()}/${vertexModelVersion.trim()}`;
        default:
            return endpoint;
    }
};
